/* Mystic Zoo — visitor sharing for artwork, collection and walkthrough pages. */
(() => {
  const initSharePanel = (root) => {
    if (root.dataset.mzShareReady === 'true') return;
    root.dataset.mzShareReady = 'true';

    const shareUrl = root.dataset.shareUrl || window.location.href;
    const shareTitle = root.dataset.shareTitle || document.title;
    const shareText = root.dataset.shareText || 'Explore Mystic Zoo’s Dark Carnival fine-art print gallery.';
    const status = root.querySelector('[data-mz-share-status]');
    const nativeShare = root.querySelector('[data-mz-native-share]');
    const copyShare = root.querySelector('[data-mz-copy-share]');

    const setStatus = (message) => {
      if (status) status.textContent = message;
    };

    if (nativeShare && navigator.share) {
      nativeShare.hidden = false;
      nativeShare.addEventListener('click', async () => {
        try {
          await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
          setStatus('Share options opened.');
        } catch (error) {
          if (error && error.name !== 'AbortError') setStatus('Sharing is unavailable in this browser.');
        }
      });
    }

    if (copyShare) {
      copyShare.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(shareUrl);
          setStatus('Link copied.');
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = shareUrl;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          field.remove();
          setStatus('Link copied.');
        }
      });
    }
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-mz-share-panel]')) initSharePanel(scope);
    scope.querySelectorAll?.('[data-mz-share-panel]').forEach(initSharePanel);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
